import api from '@/helpers/api';

export default {
  // Deprecated and not existing atm
  getInboxStats({ commit, rootState }) {
    api('GET', `inbox/organisation/${rootState.organisation.currentOrganisation.id}`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_INBOX_STATS', response.data);
        }
      });
  },
  setActiveInbox({ commit }, payload) {
    commit('SET_ACTIVE_INBOX', payload);
  },
  setCurrentAssignment({ commit }, assignment) {
    commit('SET_CURRENT_ASSIGNMENT', assignment);
  },
  setCurrentFolder({ commit }, folder) {
    commit('SET_CURRENT_FOLDER', folder);
  },
};
